<template>
    <div class="scoreboard-layout" v-if="scoreboard">
        <div class="scoreboard">
            <h3 class="heading">Žebříček</h3>
            
            <div class="first-three">
                <div v-for="index in 3" :key="index" class="box">
                    <font-awesome-icon :icon="['fas', 'medal']" class="icon" />
                    <span>{{index}}) {{ firstThree[index-1]?.username }}</span>
                </div>
            </div>

            <div class="list">
                <div class="item" v-for="(player, index) in players" :key="index">

                    <div class="name">{{player.username}}</div>
                    <div class="score">{{player.score}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import axios from "axios";

    export default {
        data(){
            return {
                scoreboard: false,
                firstThree: [],
                players: []
            }
        },
        created(){
            this.getData();
        },
        methods: {
            getData(){
                axios.get('http://localhost:3000/api/items/37')
                .then(response => {
                    console.log(response.data);

                    this.firstThree = response.data.firstThree;

                    // console.log(response.data.higherPlayers)
                    this.players = [...response.data.higherPlayers, response.data.player, ...response.data.lowerPlayers]
                }).catch(error => {
                    console.log(error);
                });

            }
        }
    }
</script>

<style lang="scss" scoped>

.scoreboard-layout{
    background: rgba(0, 0, 0, 0.6);

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    z-index: 3;

    display: flex;
    justify-content: center;
    align-items: center;

    .scoreboard{
        background: #fff;
        padding: 20px 30px;
        border-radius: 20px;

        display: flex;
        gap: 25px;
        flex-direction: column;

        .heading{
            font-size: 30px;
            font-weight: 700;
            text-align: center;
        }

        .first-three{
            display: flex;
            align-items: center;
            gap: 35px;

            .box{
                display: flex;
                flex-direction: column;
                gap: 15px;

                .icon{
                    font-size: 70px;
                }

                &:nth-child(1) .icon{
                    color: #FFCF40;
                }

                &:nth-child(2) .icon{
                    color: #BABABA;
                }

                &:nth-child(3) .icon{
                    color: #753B09;
                }
    
                span{
                    font-size: 20px;
                    font-weight: bold;
                }
            }
        }

        .list{
            display: flex;
            flex-direction: column;
            font-weight: bold;

            .item{
                display: flex;
                justify-content: space-between;

                padding: 20px 5px;
                border-bottom: 3px solid #C5C5C5;

                &:last-child{
                    border-bottom: none;
                }

                .name{

                }

                .score{

                }
            }
        }
    }
}


</style>
